import { render, staticRenderFns } from "./OrgOwnerProfileDropDown.vue?vue&type=template&id=01881c76&scoped=true&"
import script from "./OrgOwnerProfileDropDown.vue?vue&type=script&lang=js&"
export * from "./OrgOwnerProfileDropDown.vue?vue&type=script&lang=js&"
import style0 from "./OrgOwnerProfileDropDown.vue?vue&type=style&index=0&id=01881c76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01881c76",
  null
  
)

export default component.exports